// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".baseModal[data-v-7d005b16]{align-items:center;bottom:0;display:flex;justify-content:center;left:0;position:fixed;right:0;top:0;z-index:999}.baseModal__overlay[data-v-7d005b16]{-webkit-backdrop-filter:blur(26.5px);backdrop-filter:blur(26.5px);background:#000;bottom:0;left:0;opacity:.6;position:absolute;right:0;top:0;z-index:1}.baseModal__content[data-v-7d005b16]{background:#fff;border-radius:12px;padding:20px;position:relative;z-index:2}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
